import Const from "./const";
import { UrlSearch } from "./utils";

const Cookies = require("js-cookie");

export default class Auth {
	static isWeChatAuthOk() {
		return UrlSearch("code") !== undefined;
	}
	static isLocalAuthOk() {
		return Cookies.get(Const.AUTH_COOKIE_KEY) !== undefined;
	}
	static getWechatCode() {
		return UrlSearch("code") || "";
	}
	static getLocalAuthInfo() {
		return Cookies.get(Const.AUTH_COOKIE_KEY) || "";
	}
	static getLocalAuthName() {
		return Cookies.get(Const.AUTH_USER_NAME_KEY) || "";
	}
	static setLocalAuthInfo(data) {
		const { DeviceId, UserEmail } = data
		const userName = UserEmail.replace('@ucloud.cn', '').toLowerCase()
		Cookies.set(Const.AUTH_COOKIE_KEY, DeviceId);
		Cookies.set(Const.AUTH_USER_NAME_KEY, userName);
		Cookies.set(Const.AUTH_USER_EMAIL_KEY, UserEmail);
	}
	static clearLocalAuthInfo() {
		Cookies.remove(Const.AUTH_COOKIE_KEY);
		Cookies.remove(Const.AUTH_USER_NAME_KEY);
	}
}
